// src/components/CountySelector.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { COUNTIES, saveCountySelection } from '../config/counties';
import './CountySelector.css';

const goToCounty = (county) => {
  saveCountySelection(county.id);

  const { hostname, protocol, port } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isLocal) {
    const url = new URL(window.location.href);
    url.searchParams.set('county', county.id);
    window.location.href = url.toString();
    return;
  }
  const portSuffix = port ? `:${port}` : '';
  window.location.href = `${protocol}//${county.subdomain}.votergo.app${portSuffix}/`;
};

const CountySelector = () => {
  return (
    <div className="county-selector-page">
      <div className="county-selector">
        <div className="county-selector-stripe" />
        <div className="county-selector-body">
          <img src="/logo.png" alt="VoterGO" className="county-selector-logo" />
          <div className="county-selector-wordmark">
            <span className="county-selector-voter">Voter</span>
            <span className="county-selector-go">GO</span>
          </div>
          <div className="county-selector-desc">Select your county to get started</div>
          <div className="county-selector-list">
            {Object.values(COUNTIES).map(county => (
              <button
                key={county.id}
                className="county-selector-btn"
                onClick={() => goToCounty(county)}
              >
                <span>{county.name}</span>
                <span className="county-selector-arrow">
                  <ArrowRight size={16} color="currentColor" style={{ verticalAlign: 'middle' }} />
                </span>
              </button>
            ))}
          </div>
          <div className="county-selector-footer">
            Don't see your county? More counties are coming soon.
          </div>
        </div>
        <div className="county-selector-stripe" />
      </div>
    </div>
  );
};

export default CountySelector;
